// app/src/modules/ui/ThemeToggle.tsx — accessible light/dark/system switch.
import { useEffect, useState } from "react";
import { getThemePref, cycleTheme, type ThemePref } from "../../lib/theme";

const ICON: Record<ThemePref, JSX.Element> = {
  light: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
      <circle cx="12" cy="12" r="4" /><path d="M12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M19.1 4.9l-1.4 1.4M6.3 17.7l-1.4 1.4" />
    </svg>
  ),
  dark: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z" />
    </svg>
  ),
  system: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="2" y="3" width="20" height="14" rx="2" /><path d="M8 21h8M12 17v4" />
    </svg>
  ),
};
const NEXT_LABEL: Record<ThemePref, string> = { light: "dark", dark: "system", system: "light" };

export default function ThemeToggle({ style, compact = false }: { style?: React.CSSProperties; compact?: boolean }) {
  const [pref, setPref] = useState<ThemePref>("system");
  useEffect(() => { setPref(getThemePref()); }, []);

  return (
    <button
      type="button"
      onClick={() => setPref(cycleTheme())}
      title={`Theme: ${pref} — switch to ${NEXT_LABEL[pref]}`}
      aria-label={`Theme: ${pref}. Activate to switch to ${NEXT_LABEL[pref]} mode.`}
      style={{
        display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 8,
        height: 44, minWidth: compact ? 44 : undefined, padding: compact ? "0 10px" : "0 14px",
        borderRadius: "var(--r-md)", border: "1px solid var(--line)",
        background: "var(--card)", color: "var(--ink)", cursor: "pointer",
        fontFamily: "var(--body)", fontSize: 13, fontWeight: 600, ...style,
      }}
    >
      {ICON[pref]}
      {!compact && <span style={{ textTransform: "capitalize" }}>{pref}</span>}
    </button>
  );
}
